'use client';

import { useSession } from '@shared/auth';
import { capitalizeWords } from '@shared/utils';
import { useTranslations } from 'next-intl';

type ForYouTitleProps = {
  namespace: string;
};

function ForYouTitle({ namespace }: ForYouTitleProps) {
  const t = useTranslations(namespace);
  const { session } = useSession();
  const firstName = session.profile?.firstName;

  return t.rich('title', {
    name: () => <span data-track-privacy="Mask">{capitalizeWords(firstName ?? '')}</span>,
  });
}

export { ForYouTitle };
